export const DEFAULT_BOARD_NAME = "scrumlr.io";
export const MIN_PASSWORD_LENGTH = 1;
export const PLACEHOLDER_PASSWORD = "••••••••••";
export const TEMPORARY_COLUMN_ID = "TEMP_ID";
export const DEFAULT_URL = "https://scrumlr.io";

export const COMBINE_THRESHOLD = 0.13;
export const MOVE_THRESHOLD = 0.63;
export const TOAST_TIMER_DEFAULT = 5000;
export const TOAST_TIMER_SHORT = 3000;

export const MAX_NOTE_LENGTH = 1024;
export const MAX_EMOJI_SUGGESTION_COUNT = 25;
export const MIN_CHARACTERS_TO_TRIGGER_EMOJI_SUGGESTIONS = 2;

export const MAX_BOARD_NAME_LENGTH = 128;
export const MAX_BOARD_DESCRIPTION_LENGTH = 1024;
export const MAX_COLUMN_NAME_LENGTH = 128;
export const MAX_COLUMN_DESCRIPTION_LENGTH = 1024;
